// The group's lessons for 4 weeks, with flags and a "Find replacement" link per lesson (SPEC §7.3).

import type { Lesson } from "../../api/types";
import { formatDate, t } from "../../i18n/i18n";
import { formatRange } from "../../time";
import { createElement, createLink } from "../../ui/dom";
import { describeLessonFlags, lessonRoute } from "../../ui/lessonLabels";

export function buildGroupLessonsTable(lessons: Lesson[]): HTMLElement {
  const wrapper: HTMLDivElement = createElement("div", "table-scroll");
  const table: HTMLTableElement = createElement("table");
  const head: HTMLTableRowElement = table.createTHead().insertRow();
  for (const title of [t("app.date"), t("app.time"), t("lesson.teacher"), t("lesson.room"), "", ""]) {
    head.append(createElement("th", "", title));
  }

  const body: HTMLTableSectionElement = table.createTBody();
  for (const lesson of lessons) {
    body.append(buildRow(lesson));
  }

  wrapper.append(table);
  return wrapper;
}

function buildRow(lesson: Lesson): HTMLTableRowElement {
  const row: HTMLTableRowElement = createElement("tr");
  for (const text of [formatDate(lesson.key.date), formatRange(lesson.range), lesson.teacherName,
    lesson.classroomName]) {
    row.append(createElement("td", "", text));
  }

  const flags: HTMLTableCellElement = createElement("td");
  for (const label of describeLessonFlags(lesson)) {
    flags.append(createElement("span", "badge badge-flag", label));
  }

  const action: HTMLTableCellElement = createElement("td");
  const linkText: string = lesson.takesPlace ? t("groups.findReplacement") : t("lesson.title");
  action.append(createLink(lessonRoute(lesson), linkText));
  row.append(flags, action);
  return row;
}
